import ApplicationController from '../application_controller'

import { MoneyFormatter } from '../models/money_formatter'
import { useNumberHelpers } from '@/controllers/mixins/useNumberHelpers'

export default class extends ApplicationController {
  static values = {
    info: Object,
    smsCost: Number,
    countryName: String,
  }

  static targets = [
    'creditPopoverTrigger',
    'creditPopoverOption',
    'monthlySMSEstimate',
    'yearlyAgreementPrice',
    'monthlyAgreementPrice',
  ]

  initialize() {
    this.monthlyAgreement = false

    this.countryCurrency = JSON.parse(this.valueOfMetaTag('country_currency'))
    this.moneyFormatter = new MoneyFormatter(
      this.countryCurrency.code,
      {
        // 10000 is the default divisor for USD, we're calculating the prices in USD and
        // then multiplying by the currency multiplier to get the final price
        divisor: 10000,
      }
    )

    super.initialize()
  }

  connect() {
    useNumberHelpers(this)
    super.connect()
  }

  updateCredits({ currentTarget }) {
    const { quota, label } = currentTarget.dataset

    this.monthlyTotalValue = this.getTotalValueForAgreement('monthly')
    this.yearlyTotalValue = this.getTotalValueForAgreement('yearly')

    this.creditPopoverTriggerTarget.innerText = t.static.pricing_v2.credit_bundle.title.replace('%{count}', this.numberWithDelimiter(label))

    this.creditPopoverOptionTargets.forEach((option) => {
      if(option === currentTarget) {
        option.classList.add('bg-lavender-light')
      } else {
        option.classList.remove('bg-lavender-light')
      }
    })

    this.infoValue = {
      ...this.infoValue,
      features: {
        ...this.infoValue.features,
        credit: {
          ...this.infoValue.features.credit,
          available: parseInt(quota)
        }
      }
    }


    this.monthlyTotalValue = this.getTotalValueForAgreement('monthly')
    this.yearlyTotalValue = this.getTotalValueForAgreement('yearly')

    this.monthlyAgreementPriceTarget.innerHTML = t.static.pricing_v2.amount_per_month
      .replace('%{amount}', this.moneyFormatter.humanizeWithSymbolAndWithoutCurrencyCode(this.monthlyTotalValue * this.countryCurrency.multiplier))
      .replace('%{currency}', this.countryCurrency.code)

    this.yearlyAgreementPriceTarget.innerHTML = t.static.pricing_v2.amount_per_month
      .replace('%{amount}', this.moneyFormatter.humanizeWithSymbolAndWithoutCurrencyCode(this.yearlyTotalValue * this.countryCurrency.multiplier))
      .replace('%{currency}', this.countryCurrency.code)

    const monthlySmsQuota = currentTarget.dataset.default === "true" ? parseInt(quota) : parseInt(quota) + this.infoValue.features.credit.available

    this.monthlySMSEstimateTarget.innerText = t.static.pricing_v2.channels.sms
      .replace('%{count}', this.numberWithDelimiter(monthlySmsQuota / this.smsCostValue))
      .replace('%{country}', this.countryNameValue)
  }

  getTotalValueForAgreement(agreementType) {
    return Object.entries(this.infoValue.features).map(([key, feature]) => {
      if(key === 'credit_bundle') {
        const subunits = agreementType === 'monthly' ? feature.monthly_base_price : feature.yearly_base_price
        return subunits * feature.available
      }

      return ((agreementType === 'monthly' ? feature.monthly_base_price : feature.yearly_base_price) || 0) * feature.available
    }).reduce((a, b) => a + b, 0)
  }
}
